import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rValue } from '../../models/.catalog';
import { rOyakDegerlemeUstBilgi } from '../../models/rOyakDegerlemeUstBilgi';

export default class OyakDegerlemeUstBilgiApi extends ApiBase<
  pList,
  rValue<rOyakDegerlemeUstBilgi>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakDegerlemeUstBilgi',
      }),
      options
    );
  }
}
